const IResourceDispatchService = require('../IResourceDispatchService');
const RouteGaodeServiceImpl = require('../v3/internet/RouteGaodeServiceImpl');
const Util = require('./common/Util');
const ResourceDispatchUtil = require('./common/ResourceDispatchUtil');
/**
 * @classdesc 资源分析服务
 * @alias G.servicev2.ResourceDispatchServiceImpl
 * @augments G.service.IResourceDispatchService
 * @param opts
 * @param opts.httpRequest {G.base.IHttpRequest} 请求对象
 * @param opts.url {String} 服务地址
 * @param opts.routServer {Object} 路径服务
 * @param [opts.routServer.type] {String} 1=高德，默认为1
 * @param opts.routServer.url {String} 服务地址
 * @param opts.routServer.key {String} 服务key
 */
class ResourceDispatchServiceImpl extends IResourceDispatchService {
    constructor(opts) {
        super(opts);
        //
        this.routeService = new RouteGaodeServiceImpl({
            httpRequest: this.opts.httpRequest,
            url: this.opts.routServer.url,
            token: this.opts.routServer.key
        });
        //
        this.config = {
            rescue: {},
            material: {}
        };
    }

    //设置配置
    setConfig(config) {
        this.config = config;
    }

    /**
     * @inheritdoc
     */
    rescueDispatch(opts) {
        return new Promise(async(resolve, reject) => {
            let result = {
                dispatchList: []
            };
            opts.tableInfo = this.config.rescue;
            //
            let aggregateList = ResourceDispatchUtil.makeRescueAggregates(opts);
            //
            let dispatchList = await Util.aggregateMulti({
                httpRequest: this.opts.httpRequest,
                url: this.opts.url,
                aggregateList: aggregateList,
                dataParser: function(data) {
                    return ResourceDispatchUtil.extractRescueFulfillCol(opts, data);
                }
            });
            if (opts.routePlan) {
                //路径规划
                await ResourceDispatchUtil.planRoutes({
                    service: this.routeService,
                    destination: opts.destination,
                    dispatchCol: dispatchList,
                    routeParams: opts.routeParams,
                    spatialReference: opts.spatialReference
                });
            }
            result.dispatchList = dispatchList;
            resolve(result);
        });
    }

    /**
     * @inheritdoc
     */
    materialDispatch(opts) {
        return new Promise(async(resolve, reject) => {
            let result = {
                dispatchList: []
            };
            opts.tableInfo = this.config.material;
            //
            let aggregateList = ResourceDispatchUtil.makeMaterialAggregates(opts);
            //
            let dispatchList = await Util.aggregateMulti({
                httpRequest: this.opts.httpRequest,
                url: this.opts.url,
                aggregateList: aggregateList,
                dataParser: function(data) {
                    return ResourceDispatchUtil.extractMaterialFulfillCol(opts, data);
                }
            });
            if (opts.routePlan) {
                //路径规划
                await ResourceDispatchUtil.planRoutes({
                    service: this.routeService,
                    destination: opts.destination,
                    dispatchCol: dispatchList,
                    routeParams: opts.routeParams,
                    spatialReference: opts.spatialReference
                });
            }
            result.dispatchList = dispatchList;
            resolve(result);
        });
    }
}

module.exports = ResourceDispatchServiceImpl;